import React, { Component } from 'react';
import { getMode2Icon, isEmpty } from '../../../../Common/Common';

export default class Mode2 extends Component {
	constructor(props) {
		super(props);
		
// 		let mode2 = 'NON';
// 		if (!isEmpty(this.props.point_info)) {
// 			if (this.props.point_info.mode2 != null) {
// 				mode2 = this.props.point_info.mode2;
// 			}
// 		}
//.
// 		this.state = {
// 			mode2: mode2,
// 			icon: getMode2Icon(mode2)
// 		}
	}

	handleChangeMode2 = () => {
		if(this.props.modeTapped) return; 					//Do not process click if mode is tapped.
		if(this.props.availableMode2.length == 1) return;  	//Do no need to process if available mode2 is only 1

		let new_mode = 'NON';

		//let mode2 = this.state.mode2;
		let mode2 = this.props.mode2;

		let existingArrayPosition = this.props.availableMode2.indexOf(this.props.mode2); //not found == -1
		let arrayLength = this.props.availableMode2.length;

		existingArrayPosition++;	//increment by one. If not found, will become 0. If end of array, will == array.length

		if(existingArrayPosition < arrayLength) {
			new_mode = this.props.availableMode2[existingArrayPosition];
		} else {
			new_mode = this.props.availableMode2[0];
		}

// 		this.setState({
// 			mode2: new_mode,
// 			icon: getMode2Icon(new_mode)
// 		})

		this.props.handleChangeMode2(new_mode);
	}

	render() {
		let label = this.props.receiver.getString('NON')

		if(this.props.availableMode2.includes(this.props.mode2)) {
			label = this.props.mode2;
		}

		this.icon = getMode2Icon(this.props.mode2);

		return (
			<div id='mode2' style={this.props.style} onClick={this.handleChangeMode2}>
				<div>
					<img src={this.icon} style={{ width: 40 }} />
				</div>

				<div>
					<span> {this.props.receiver.getString(label)} </span>
				</div>
			</div>
		)
	}
}
